import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import classes from "./SubscriptionPage.module.css";
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import SmallLoader from '../components/Loaders/SmallLoader';
import OTPInput from "react-otp-input";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
// import { getPacks } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
// import { SendOtpAPI } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import TermsModal from '../components/TermsModal';
import { sendOtp ,login} from '../http/http';

import Lottie from 'lottie-react';
import snowfallAnimation from "../animations/snowfall-animation.json";
import starsAnimation from "../animations/starsAnimation.json";
import wordAnimation from "../animations/guessWordAnimation.json";
import gridAnimation from "../animations/gridAnimation.json";

const SubscriptionPage = () => {
    const { t } = useTranslation();
    const [msisdn, setMsisdn] = useState("");
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [termsModal, setTermsModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [pack, setPack] = useState("Daily");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (userToken) {
            navigate("/home");
        }
    }, [userToken]);

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoading(true);

            const response = await sendOtp(msisdn, extRef);
            console.log(response, 'response...');
            if (response.status==0) {
               return  await login({ msisdn: msisdn })
                                .then((res) => {
                                    
                                    dispatch(setUserToken(res?.data?.result?.token));
                                    navigate("/home");
                                    toast.success(t("84"));
                                })
                                .catch((err) => {
                                    
                                    if (err?.response?.data?.error?.status == 0) {
                                        toast.error(t("86"));
                                        
                                    }
                                    else if (err?.response?.data?.error?.status == 1) {
                                        navigate("/low-balance");
                                    }
                                    else {
                                        toast.error(t("86"));
                                    }
                                });
                
            }
            // console.log(response?.data, 'data 1')
            // console.log(response?.data?.data, 'data2 ');
            // console.log(response?.data?.data?.referenceNo);

            setLoading(false);
            navigate("/otp", {
                state: {
                    msisdn: msisdn,
                    extRef:extRef,
                    pack
                }
            })

        } catch (error) {
            console.log(error, 'error---');
            setLoading(false);
            if (error?.response?.data?.status == 1) {
                toast.error(t("126"));
            }
            else if (error?.response?.data?.status == 2) {
                toast.error(t("125"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            <Header />

            <div className={classes.container}>
                <h1 className={classes.heading}>
                    <span style={{ color: '#3550dc' }}>Quiz Masters</span>{" "}{t("59")}
                </h1>

                     <div className={classes.word_game_container}>
                    <div className={classes.word_game_sub_container}>
                        <Lottie
                            animationData={starsAnimation}
                            loop
                            autoPlay
                            className={classes.animation_stars}
                        />
                    </div>

                    <div className={classes.grid_animation_container}>
                        <Lottie
                            animationData={gridAnimation}
                            loop
                            autoPlay
                            className={classes.grid_animation}
                        />
                    </div>

                    <div className={classes.photo_container}>
                        <Lottie
                            animationData={wordAnimation}
                            loop
                            autoPlay
                            className={classes.photo}
                        />
                    </div>

                    <div className={classes.word_game_content}>
                        <p className={classes.word_game_badge}>FREE GAME</p>
                        <h1 className={classes.word_game_heading}>Zip Game</h1>
                        <p className={classes.word_game_text}>
                            Play for free and get the chance to win rewards
                        </p>

                        <button
                            type="button"
                            className={classes.word_play_btn}
                            onClick={() => navigate("/register/zip-game")}
                        >
                            Play for Free
                        </button>
                    </div>
                </div>
                
                <div className={classes.actions_box_container}>
                    <div className={classes.actions_box}>
                        <button className={`${classes.action_box}`}
                            type='button'
                            onClick={() => navigate(`/login?ext_id=${extRef}`)}>
                            {t("60")}
                        </button>
                        <button className={`${classes.action_box} ${classes.active}`}>
                            {t("63")}
                        </button>
                    </div>
                </div>

                <form className={classes.form} onSubmit={handleFormSubmission}
                >
                    <div className={classes.username_field_form}>
                        <div className={classes.country_code}>
                            <img src="/assets/images/FlagGB.png" alt="flag" className={classes.flag} />
                            <p className={classes.country_code_number}>+245</p>
                        </div>
                        <input
                            id="msisdn"
                            name="msisdn"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            autoFocus placeholder={t("62")} className={classes.input_field_username}
                            onChange={(e) => {
                                setMsisdn(e.target.value)
                            }}
                            value={msisdn}
                        />
                    </div>

                    <div className={classes.packs}>
                        <p className={classes.packs_heading}>{t("63")}</p>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_blue}`}
                            onClick={() => setPack("Daily")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_blue}`}>{t("119")}</span>
                            {
                                pack === "Daily" ?
                                    <div className={`${classes.checked_radio} ${pack === "Daily" && classes.shade_blue}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                60 FCFA{" "}/{t("102")}
                                
                            </p>
                        </button>

                        <button type='button' className={`${classes.pack_box} ${classes.shade_green}`}
                            onClick={() => setPack("Weekly")}
                        >
                            <span className={`${classes.pack_header} ${classes.shade_green}`}>{t("120")}</span>
                            {
                                pack === "Weekly" ?
                                    <div className={`${classes.checked_radio} ${pack === "Weekly" && classes.shade_green}`}>
                                        <FaCheck className={classes.checked_icon} />
                                    </div>
                                    : <div className={classes.dummy_radio}>

                                    </div>
                            }
                            <p className={`${classes.pack_price_point} ${classes.active}`}>
                                350 FCFA{" "}/{t("118")}
                                
                            </p>
                        </button>

                    </div>

                    <div className={classes.check_box_container}>
                        <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                            className={classes.check_box} checked
                        >
                        </input>
                        <label for="terms" className={classes.check_box_label}>
                            {t("99")}{" "}<span className={classes.link} onClick={() => setTermsModal(true)}>{t("114")}</span>
                        </label>
                    </div>

                    <button type="submit"
                        disabled={loading}
                        className={classes.login_btn}>{
                            loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("61")
                        }</button>
                    <div className={classes.footer}>
                        <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                    </div>
                </form>

            </div>

            {termsModal && <TermsModal setTermsModal={setTermsModal} />}
        </>
    )
}

export default SubscriptionPage